<template>

<div class="modal" id="reviewReport">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">Report Review</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body" v-if='review'>
                <div class='row' v-if='!isReady'>
                    <div class="col-12">
                        <loader></loader>
                    </div>
                </div>

                <div class="row" v-if='isReady'>
                    <div class="col-12 mb-4">
                        Report review: <strong>"{{ review.title }}" by author "{{ review.author }}"</strong> 
                    </div>

                    <div class="col-12">

                        <div v-if='hasReport' class="alert alert-info">
                            <div class="alert-icon">
                                <span class="icon icon-poker-face"></span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center w-100">
                                <div>
                                    <span class="text-bold d-block">Done!</span>
                                    <span class="text-small">You have submited a report for this review.</span>
                                </div>
                            </div>
                        </div>

                        <div v-if='!hasReport' class="text-center">
                            <textarea class='form-control' placeholder="Please describe whats wrong"></textarea>
                            <button @click='sendReport' class='btn btn-primary mt-4'>
                                Send Report
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button> -->
            </div>

        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            
            return {
                isReady : false,
                hasReport : false,
                review : false,

                report : false,

                repMdl : {
                    report : ''
                }
            }

        },

        methods : {

            open( r ) {
                this.isReady = false;
                this.review = r;

                this.getData();

                $("#reviewReport").modal('show');
            },

            getData() {

                this.ajax.call('rvw:gur',{ r : this.review.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        //Has report
                        if( r.data ) {
                            
                            this.hasReport = true;
                            this.report = r.data;
                        
                        } else {
                            
                            this.report = Object.assign({}, this.repMdl, { review_id : this.review.id });

                        }

                        this.isReady = true;

                    }

                })
            },

            sendReport() {
                if( !this.hasReport ) {

                    this.ajax.call('rvw:sur', this.report, (r) => {

                        if( r.status == 'success' ) {
                            $.notify('Your report has been submited','success');
                            this.hasReport = true;
                        }

                    })

                }
            }

        }

    }
</script>
